<template>
	<div class="tcp-page tcp-info">
		<section class="tcp-info__hero">
			<p class="tcp-kicker">Get in Touch</p>
			<h1>Contact Us</h1>
			<p>We're here to help. Reach out for product questions, order support, or anything else on your mind.</p>
		</section>

		<section class="tcp-contact">
			<aside>
				<h2>Ways to Reach Us</h2>
				<div v-if="site.email" class="tcp-contact__row">
					<span class="tcp-info__icon"><i class="fa fa-envelope-o"></i></span>
					<div>
						<p>Email</p>
						<a :href="'mailto:' + site.email">{{ site.email }}</a>
					</div>
				</div>
				<div v-if="site.phone" class="tcp-contact__row">
					<span class="tcp-info__icon"><i class="fa fa-phone"></i></span>
					<div>
						<p>Phone</p>
						<a :href="'tel:' + site.phone">{{ site.phone }}</a>
					</div>
				</div>
				<div v-if="site.address" class="tcp-contact__row">
					<span class="tcp-info__icon"><i class="fa fa-map-marker"></i></span>
					<div>
						<p>Address</p>
						<span>{{ site.address }}</span>
					</div>
				</div>
				<div class="tcp-contact__row">
					<span class="tcp-info__icon"><i class="fa fa-clock-o"></i></span>
					<div>
						<p>Support Hours</p>
						<span>Mon – Fri: 9AM – 6PM EST</span>
						<span>Sat: 10AM – 3PM EST</span>
					</div>
				</div>

				<div class="tcp-contact__links">
					<p>Quick Links</p>
					<ul>
						<li><router-link to="/faq">FAQ</router-link></li>
						<li><router-link to="/shipping">Shipping Info</router-link></li>
						<li><router-link to="/returns">Returns & Refunds</router-link></li>
					</ul>
				</div>
			</aside>

			<div v-if="sent" class="tcp-contact__card tcp-contact__sent">
				<span class="tcp-info__icon"><i class="fa fa-comment-o"></i></span>
				<h2>Message Sent</h2>
				<p>Thank you for reaching out. Our team will respond to your inquiry within 1–2 business days.</p>
				<button type="button" class="tcp-btn tcp-btn--outline" @click="reset">Send Another Message</button>
			</div>

			<form v-else class="tcp-contact__card" @submit.prevent="submit">
				<h2>Send a Message</h2>
				<div class="tcp-contact__grid">
					<label>
						Name
						<input v-model="form.name" type="text" placeholder="Your name" required>
					</label>
					<label>
						Email
						<input v-model="form.email" type="email" placeholder="your@email.com" required>
					</label>
					<label class="is-wide">
						Subject
						<select v-model="form.subject" required>
							<option value="">Select a topic...</option>
							<option value="Order Issue">Order Issue</option>
							<option value="Product Question">Product Question</option>
							<option value="Return or Refund">Return or Refund</option>
							<option value="Shipping Inquiry">Shipping Inquiry</option>
							<option value="Other">Other</option>
						</select>
					</label>
					<label class="is-wide">
						Message
						<textarea v-model="form.message" rows="6" placeholder="Tell us how we can help..." required></textarea>
					</label>
				</div>
				<button type="submit" class="tcp-btn" :disabled="!canSend">Send Message</button>
			</form>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sent: false,
			site: {
				email: '',
				phone: '',
				address: ''
			},
			form: {
				name: '',
				email: '',
				subject: '',
				message: ''
			}
		}
	},
	computed: {
		canSend() {
			return this.form.name && this.form.email && this.form.subject && this.form.message
		}
	},
	mounted() {
		axios.get(tools.url('/api/store/site')).then((response) => {
			this.site = Object.assign({}, this.site, response.data || {})
		}).catch(() => {})
	},
	methods: {
		submit() {
			if (!this.canSend) return
			this.sent = true
		},
		reset() {
			this.form = { name: '', email: '', subject: '', message: '' }
			this.sent = false
		}
	}
}
</script>
